var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3852_12812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 9.33984C3.20999 9.43575 3.24225 9.54764 3.24225 9.65953C3.20999 9.54764 3.19386 9.45173 3.17773 9.33984Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17773 9.33984C3.20999 9.43575 3.24225 9.54764 3.24225 9.65953C3.20999 9.54764 3.19386 9.45173 3.17773 9.33984Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77388 3.71243C6.9513 3.63251 6.32227 2.9452 6.32227 2.11403C6.32227 1.29884 6.93517 0.627513 7.72549 0.515625C7.80614 0.515625 7.87065 0.515625 7.9513 0.515625C8.03194 0.515625 8.11259 0.515625 8.1771 0.515625C10.3061 0.579561 12.2416 1.45868 13.661 2.86528C13.9674 4.87926 14.5642 11.5126 9.46743 13.0631C11.4029 12.4397 12.8061 10.6335 12.8061 8.50763C12.8061 5.91822 10.7255 3.80833 8.14485 3.71243H7.77388Z",
    fill: "#2B94FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.50723C16 12.9188 12.3871 16.4992 7.93548 16.4992C4.14516 16.4992 0.967742 13.8938 0.0967742 10.3933C0.0645161 10.2335 0.0322581 10.0737 0 9.92981C0 9.89784 0 9.86587 0 9.83391C0 8.9388 0.725806 8.21952 1.62903 8.21952C2.35484 8.21952 2.96774 8.68306 3.17742 9.3384C3.19355 9.45029 3.20968 9.56218 3.24194 9.65808C3.75806 11.752 5.66129 13.3024 7.93548 13.3024C8.25806 13.3024 8.56452 13.2705 8.85484 13.2225C8.98387 13.1905 9.1129 13.1746 9.24193 13.1266C9.30645 13.1106 9.37097 13.0946 9.41936 13.0787C14.5323 11.5282 13.9194 4.89485 13.6129 2.88086C15.0968 4.30344 16 6.30144 16 8.50723Z",
    fill: "#35639C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16157 0.515984C8.08093 0.515984 8.01641 0.515984 7.93577 0.515984C7.85512 0.515984 7.79061 0.515984 7.70996 0.515984C7.79061 0.5 7.87125 0.5 7.93577 0.5C8.01641 0.5 8.09706 0.5 8.16157 0.515984Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24225 9.65953C3.20999 9.54764 3.19386 9.45173 3.17773 9.33984C3.20999 9.43575 3.22612 9.54764 3.24225 9.65953Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8068 6.03099C3.7243 6.03099 4.46809 5.29389 4.46809 4.38463C4.46809 3.47538 3.7243 2.73828 2.8068 2.73828C1.88929 2.73828 1.14551 3.47538 1.14551 4.38463C1.14551 5.29389 1.88929 6.03099 2.8068 6.03099Z",
    fill: "#2B94FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3852_12812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubot);
export default __webpack_public_path__ + "static/media/Subot.ff86cd81c8663723abce344f1654d35e.svg";
export { ForwardRef as ReactComponent };